// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"676":"afac320f","770":"e8ca9c5b","787":"0f92556f","988":"1011a30e","993":"60c90187"}[chunkId] + ".chunk.js";
};